import API from 'apis/API';

/**
 * /v4/status
 */
export const getStatus = async () => {
  const res = await API.get('/v4/status');

  return res.data;
};
